import { toFiniteSeriesNumber } from './toFiniteSeriesNumber';

/**
 * Convert each row's series values to fractions of that row's total
 * (stacked-percent bars from raw-count queries).
 */
export function normalizeRowsToShare(
  rows: Record<string, unknown>[],
  seriesKeys: string[],
): Record<string, unknown>[] {
  return rows.map((row) => {
    let total = 0;
    for (const key of seriesKeys) {
      const n = toFiniteSeriesNumber(row[key]);
      if (n !== null) total += n;
    }
    if (total === 0) return row;

    const out: Record<string, unknown> = { ...row };
    for (const key of seriesKeys) {
      const n = toFiniteSeriesNumber(row[key]);
      out[key] = n === null ? null : n / total;
    }
    return out;
  });
}
